import components from './components.json';
import layout from './layout.json';
import validation from './validation.json';
const common = {
   components,
   layout,
   validation,
};
export default common;
